import type { AffiliatesRouter } from "replo-publisher/src/trpc/routers/affiliates";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: affiliatesRouter,
  client: affiliatesClient,
  utils: affiliatesUtils,
  options: affiliatesOptions,
} = createTrpcRouterConfig<AffiliatesRouter>({
  path: "affiliates",
  queryClient: getNamespacedQueryClient("affiliates"),
});

export {
  affiliatesClient,
  affiliatesRouter,
  affiliatesUtils,
  affiliatesOptions,
};
